import { render, staticRenderFns } from "./CrossBorderCustomerIncomeDetailStatement.vue?vue&type=template&id=9b321f82&scoped=true"
import script from "./CrossBorderCustomerIncomeDetailStatement.vue?vue&type=script&lang=js"
export * from "./CrossBorderCustomerIncomeDetailStatement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b321f82",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9b321f82')) {
      api.createRecord('9b321f82', component.options)
    } else {
      api.reload('9b321f82', component.options)
    }
    module.hot.accept("./CrossBorderCustomerIncomeDetailStatement.vue?vue&type=template&id=9b321f82&scoped=true", function () {
      api.rerender('9b321f82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/bulletinBoard/receivablesStatistics/CrossBorderCustomerIncomeDetailStatement.vue"
export default component.exports